'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = wrapper;

var _createReauthHandler = require('./createReauthHandler');

var _createReauthHandler2 = _interopRequireDefault(_createReauthHandler);

var _createUnauthorizedApiResponseHandler = require('./createUnauthorizedApiResponseHandler');

var _createUnauthorizedApiResponseHandler2 = _interopRequireDefault(_createUnauthorizedApiResponseHandler);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function wrapper(reauth, apiContext) {
  var reauthHandler = (0, _createReauthHandler2.default)(reauth, apiContext);

  return function (apiFunc) {
    return function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var apiAuth = null;

      var apiHandler = _createUnauthorizedApiResponseHandler2.default.apply(undefined, [apiFunc].concat(args));

      var authInjectionHandler = function authInjectionHandler(apiResponse) {
        apiResponse.auth = apiAuth;

        return apiResponse;
      };

      var authErrorInjectionHandler = function authErrorInjectionHandler(apiResponse) {
        return Promise.reject(authInjectionHandler(apiResponse));
      };

      var apiCallback = function apiCallback() {
        return reauthHandler(apiHandler).then(function (handlerResponse) {
          // If auth data exists, then reauth occurred. We must store the auth data and perform
          // the original api call. Otherwise, the response is the api call response which we
          // should just pass along.
          if (handlerResponse.auth) {
            apiAuth = handlerResponse.auth;

            return apiHandler();
          }

          return handlerResponse;
        }).then(authInjectionHandler, authErrorInjectionHandler);
      };

      return apiHandler(apiCallback);
    };
  };
}
//# sourceMappingURL=wrapper.js.map